export default __webpack_public_path__ + "static/media/volunteer6.b7756e7f.jpg";